
import { defineComponent } from "vue";
import ApiService from "@/core/services/ApiService";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default defineComponent({
  name: "merchant-api-card",
  emit: ["edit", "refresh"],
  components: {},
  props: {
    cardClasses: String,

    icon: String,

    endpointDomain: String,

    endpointName: String,

    aliasName: String,

    connName: String,

    color: String,

    arrow: String,

    endpointStatus: String,

    indicatorValue: String,

    indicatorLabel: String,

    isWarning: Boolean,

    api: Object,

    apiId: String,
    merchantId: String,
    midNumber: String,
    apiEnabled: String,

  },
  setup(props, { emit }) {
    const editAPI = () => {
      emit("edit", props.api);
    };

    const deleteMerchantAPI = async () => {
      try {
        const { data } = await ApiService.delete(
          `apis/merchants/${props.apiId}`
        );
        if (data.success === true) {
          Swal.fire({
            text: "Api Successfully deleted!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          });
          emit("refresh");
        } else {
          Swal.fire({
            text: data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
    };
    return {
      deleteMerchantAPI,
      editAPI,
    };
  },
});
